module.exports = __webpack_public_path__ + "img/logo_wide@x2.38f9109.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/logo_wide@x2.png
// module id = qTJc
// module chunks = 66